/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

//phoenix imports
import { Orientation } from '@airasia-phoenix/react-native/utils/utils';

export const Constants = {
  IMAGE_HEIGHT: 150,
  IMAGE_WIDTH: 150,
  INITIAL_LOAD_IMAGE_COUNT: 10,
  SUBSEQUENT_LOAD_IMAGE_COUNT: 10,
  CAROUSEL_HEIGHT: 320,
  get CAROUSEL_ORIENTATION() {
    const horizontalSpacingInCards = 12 / 2.5;
    const rowCount = 1;
    return new Orientation.Horizontal(0, rowCount, horizontalSpacingInCards, 0);
  },
  SCROLL_SPEED: 0.85,
  CURRENCY_SCALE_MILLION: 1_000_000,
};
